import React from "react";
import { SummaryMetricId, SummarySidebarItem } from "../types/summaryDashboard.types";

type SummarySidebarProps = {
  items: SummarySidebarItem[];
  activeMetricId: SummaryMetricId;
  onChange: (metricId: SummaryMetricId) => void;
};

const SummarySidebar: React.FC<SummarySidebarProps> = ({
  items,
  activeMetricId,
  onChange,
}) => {
  return (
    <div className="summary-sidebar nav flex-nowrap flex-lg-column nav-pills gap-2 w-100">
      {items.map((item) => {
        const isActive = item.id === activeMetricId;

        if(!item.value)
          return '';

        if(item.id=='totalProfit'){
          if(item.value>0){
            item.bgClass='bg-success-subtle';
            item.textClass='text-success-emphasis';
            //item.value='+'+item.value;
          }else{
            item.bgClass='bg-danger-subtle';
            item.textClass='text-danger-emphasis';
          }
        }

        return (
          <button
            key={item.id}
            type="button"
            className={[
              "nav-link",
              item.bgClass,
              item.textClass,
              "text-start",
              "py-3",
              isActive ? "active shadow border border-dark" : "",
            ]
              .filter(Boolean)
              .join(" ")}
            onClick={() => onChange(item.id)}
          >
            <div className="metric-value fw-bold">{item.value}</div>
            <div className="metric-label">{item.label}</div>
          </button>
        );
      })}
    </div>
  );
};

export default SummarySidebar;
